// src/Paginas/Hero.jsx
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="hero-section position-relative d-flex align-items-center">
      {/* Overlay oscuro */}
      <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100" />

      {/* Efecto de luz cálida */}
      <div className="hero-light-effect position-absolute" />

      <Container className="hero-container position-relative">
        <Row className="hero-row align-items-center">
          <Col lg={7} md={8} className="text-white">

            {/* Badge decorativo */}
            <div className="hero-badge d-inline-block px-4 py-2 mb-4 mt-2 rounded-pill">
              <span className="hero-badge-text">
                ✦ COLECCIÓN EXCLUSIVA ✦
              </span>
            </div>

            {/* H1 principal */}
            <h1 className="hero-title mb-3">
              <span className="hero-title-main d-block">
                LUMIÈRE
              </span>

              <span className="hero-title-accent d-block">
                TICA
              </span>

              <span className="hero-subtitle d-block mt-3">
                Velas Aromáticas Artesanales
                <span className="hero-subtitle-location d-inline-block ms-2">
                  · Costa Rica
                </span>
              </span>
            </h1>

            {/* Slogan */}
            <div className="d-flex align-items-center gap-3 mb-4">
              <div className="hero-slogan-line" />

              <p className="hero-slogan-text fs-4 mb-0">
                "Luz que abraza tus sentidos"
              </p>

              <div className="hero-slogan-line" />
            </div>

            {/* Descripción */}
            <p className="hero-description fs-5 mb-4">
              Descubre nuestra exclusiva colección de velas aromáticas
              artesanales, creadas para transformar cada momento en una
              experiencia única.
            </p>

            {/* Botones CTA */}
            <div className="d-flex flex-wrap gap-3 mt-4">

              {/* Comprar Ahora */}
              <Button
                as="a"
                href="#productos"
                className="hero-btn-primary px-5 py-3 rounded-pill d-flex align-items-center gap-2"
              >
                <i className="fas fa-shopping-bag"></i>
                Comprar Ahora
              </Button>

              {/* Conocer Más */}
              <Button
                as={Link}
                to="/sobre-nosotros"
                className="hero-btn-secondary px-5 py-3 rounded-pill d-flex align-items-center gap-2"
              >
                <i className="fas fa-info-circle"></i>
                Conocer Más
              </Button>
            </div>

            {/* Características */}
            <div className="d-flex gap-5 mt-5 pt-3">
              <div>
                <span className="hero-feature-value d-block fs-3 fw-bold">
                  Variedad
                </span>

                <span className="hero-feature-label">
                  de aromas
                </span>
              </div>

              <div>
                <span className="hero-feature-value d-block fs-3 fw-bold">
                  Cera
                </span>

                <span className="hero-feature-label">
                  de soya
                </span>
              </div>

              <div>
                <span className="hero-feature-value d-block fs-3 fw-bold">
                  8%
                </span>

                <span className="hero-feature-label">
                  de fragancia
                </span>
              </div>
            </div>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
